/* SIPL Diwali 2026 — light layer
   1) diya pair on section titles   2) small gold spark on key buttons
   3) firework on add-to-cart       4) one welcome firework per visit
   The canvas exists only while something is animating, so idle pages cost nothing.
   Skipped entirely for visitors with prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.__siplDiwali) return;
  window.__siplDiwali = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1) diya pair on titles (works with or without motion) ---------- */
  var TITLES = [
    '.section__header .heading:not(.heading--small)', '.section__header h2:not(.heading--small)',
    '.shop-by-category__title', '.er-heading', '.hotdeals__title', '.custom-faq-new__title', '.blogs4__title', '.brand-grid__heading',
    '.logo-grid-heading', '.faq2c__heading', '.custom-ppf__heading', '.custom-text-video-heading', '.section-heading', '.main-heading',
    '.sipl-collection-banner-title', '.page-header .heading', '.sipl-browse-by-car__brand'
  ].join(',');
  var SKIP = 'header, footer, .drawer, .popover, .modal, .sd-strip, .sd-banner, .product-item, [class*="card"]';

  function decorate(scope) {
    var list = (scope || document).querySelectorAll(TITLES);
    for (var i = 0; i < list.length; i++) {
      var h = list[i];
      if (h.hasAttribute('data-sd-title') || h.closest(SKIP) || !h.textContent.trim()) continue;
      var a = getComputedStyle(h).textAlign;
      if (a === 'center') h.setAttribute('data-sd-title', 'center');
      else if (a === 'left' || a === 'start') h.setAttribute('data-sd-title', 'left');
    }
  }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () { decorate(); });
  document.addEventListener('shopify:section:load', function (e) { decorate(e.target); });

  if (reduce) return;

  /* ---------- fireworks (lazy canvas) ---------- */
  var cv = null, ctx = null, W = 0, H = 0, mobile = false, parts = [], rockets = [], rings = [], raf = null, last = 0, killTimer = null;
  var PAL = [['#e6a100', '#ffb000', '#ffc94d'], ['#ff8a1f', '#e6a100', '#ffc94d'], ['#1141cc', '#2a6bff', '#ffb000'], ['#e6a100', '#ffb000', '#2a6bff']];
  function rnd(a, b) { return Math.random() * (b - a) + a; }
  function pick(a) { return a[(Math.random() * a.length) | 0]; }

  function ensure() {
    clearTimeout(killTimer);
    if (cv) return true;
    cv = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;z-index:9990;pointer-events:none';
    document.body.appendChild(cv);
    W = window.innerWidth; H = window.innerHeight; mobile = W <= 767;
    var dpr = Math.min(window.devicePixelRatio || 1, mobile ? 1 : 1.5);
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return !!ctx;
  }
  function wake() { if (!raf) { last = 0; raf = requestAnimationFrame(frame); } }

  function spark(x, y, vx, vy, life, r, c) {
    if (parts.length > (mobile ? 150 : 280)) parts.shift();
    parts.push({ x: x, y: y, px: x, py: y, vx: vx, vy: vy, life: life, max: life, r: r, c: c });
  }
  function burst(x, y, n, power, shape) {
    var pal = pick(PAL), i, a, s;
    rings.push({ x: x, y: y, r: 4, a: .5, c: pal[0], grow: 2.6 * power });
    for (i = 0; i < n; i++) {
      a = (Math.PI * 2 * i) / n + rnd(-.03, .03);
      s = shape === 'ring' ? 3 * power : (shape === 'star' ? (1.2 + 2.6 * Math.abs(Math.cos(2.5 * a))) * power : rnd(1.3, 3.9) * power);
      spark(x, y, Math.cos(a) * s, Math.sin(a) * s, rnd(40, 66), rnd(1.1, 2), pick(pal));
    }
  }
  function launch(tx) {
    if (!ensure()) return;
    rockets.push({ x: tx + rnd(-30, 30), y: H + 8, tx: tx, ty: rnd(H * .16, H * .42), vy: -rnd(mobile ? 7 : 8, mobile ? 8.6 : 10) });
    wake();
  }
  function frame(now) {
    raf = null;
    var dt = last ? Math.min((now - last) / 16.67, 2.2) : 1; last = now;
    ctx.clearRect(0, 0, W, H);
    var i, p, r;
    for (i = rockets.length - 1; i >= 0; i--) {
      r = rockets[i]; r.y += r.vy * dt; r.x += (r.tx - r.x) * .02 * dt; r.vy *= .985;
      spark(r.x, r.y, rnd(-.3, .3), rnd(.2, .8), 12, 1.3, '#ffb000');
      ctx.globalAlpha = 1; ctx.fillStyle = '#e6a100'; ctx.beginPath(); ctx.arc(r.x, r.y, 2.3, 0, 6.2832); ctx.fill();
      if (r.y <= r.ty || r.vy > -1.2) { burst(r.x, r.y, mobile ? 46 : 78, rnd(.95, 1.25), pick(['peony', 'ring', 'star'])); rockets.splice(i, 1); }
    }
    for (i = rings.length - 1; i >= 0; i--) {
      r = rings[i]; r.r += r.grow * dt; r.a -= .035 * dt;
      if (r.a <= 0) { rings.splice(i, 1); continue; }
      ctx.globalAlpha = r.a; ctx.strokeStyle = r.c; ctx.lineWidth = 1.8; ctx.beginPath(); ctx.arc(r.x, r.y, r.r, 0, 6.2832); ctx.stroke();
    }
    for (i = parts.length - 1; i >= 0; i--) {
      p = parts[i]; p.px = p.x; p.py = p.y;
      p.vx *= .975; p.vy = p.vy * .975 + .045 * dt; p.x += p.vx * dt; p.y += p.vy * dt; p.life -= dt;
      if (p.life <= 0) { parts.splice(i, 1); continue; }
      var k = p.life / p.max;
      ctx.globalAlpha = k; ctx.strokeStyle = p.c; ctx.lineWidth = p.r * (.5 + k * .6); ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(p.px, p.py); ctx.lineTo(p.x, p.y); ctx.stroke();
    }
    ctx.globalAlpha = 1;
    if (parts.length || rockets.length || rings.length) raf = requestAnimationFrame(frame);
    else { ctx.clearRect(0, 0, W, H); killTimer = setTimeout(function () { if (cv && !raf) { cv.remove(); cv = ctx = null; } }, 800); }
  }

  /* ---------- 2) small spark on key buttons ---------- */
  var KEY_BTN = '.button--primary, .button--secondary, .product-form__add-button, .sd-banner__btn, .sd-strip__cta';
  var lastBtn = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.button > 0) return;
    var el = e.target.closest && e.target.closest(KEY_BTN);
    if (!el || el.disabled || !ensure()) return;
    lastBtn = el;
    burst(e.clientX, e.clientY, mobile ? 12 : 20, .5, 'peony'); wake();
  }, true);

  /* ---------- 3) add-to-cart firework ---------- */
  document.addEventListener('variant:added', function () {
    if (!ensure()) return;
    var x = W / 2, y = H * .4;
    if (lastBtn) { var b = lastBtn.getBoundingClientRect(); if (b.width) { x = b.left + b.width / 2; y = Math.max(b.top - 50, 60); } }
    burst(x, y, mobile ? 56 : 96, 1.15, 'star');
    setTimeout(function () { if (ensure()) { burst(x + rnd(-80, 80), y - 30, mobile ? 40 : 64, .9, 'peony'); wake(); } }, 220);
    wake();
  }, true);

  /* ---------- 4) one welcome firework per visit ---------- */
  ready(function () {
    var seen = false;
    try { seen = sessionStorage.getItem('sipl-diwali-welcome') === '1'; sessionStorage.setItem('sipl-diwali-welcome', '1'); } catch (e) {}
    if (seen) return;
    setTimeout(function () { var w = window.innerWidth; launch(w * .25); setTimeout(function () { launch(w * .75); }, 450); setTimeout(function () { launch(w * .5); }, 1000); }, 900);
  });
})();
